import axios from 'axios' //引入axios
import store from '@/store';
//import globelVar from '@/globelVar.js'

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.timeout = 30000
export default {
  readIDCard(){
    //查询患者信息
    return axios({
        method:'get',
        url: '/data/hardware/readIDCard',//globelVar.env.hardWare+"/readIDCard",//"/api/dataForJSONForSQLServer",//globelVar.env.hardWare+"/readIDCard"
        data: {
          method:"readId"
        }
      }).then(res => {
        return res.data;     
      }).catch(err => {
        console.error(err); 
        return err.data        
      });

  },
  
  //返回Promise 对象
  //funcode 目前支持 readidcard 身份证，readsicard 社保卡，readsieccode医保电子凭证，print凭条打印，gethardwaresatus获取硬件状态,log日志
  //devinfo 获取自助机版本号
 async  execute(funcode,input){ 
  
  // console.log("打印",window.chrome.webview)
  if(window.chrome.webview) 
    {
    //主机调用C#方法是异步的 
    let FunsObject = await window.chrome.webview.hostObjects.execute;//.sync
    let res =await FunsObject.Fun(funcode,input);
    // console.log("execute",res);
    return  JSON.parse(res);
    }
  else
    return "366666766";
},
   
  request(code,input){
    return axios({
        method:'get',
        url: "/data/"+code,
        data: {
          "input":input
        }
      }).then(res => {
        //console.log(res)
        return res.data;     
      }).catch(err => {
        //console.error(err); 
        return err.data        
      });
  },
  request_pro(code,input){
    // console.log("11111"+input);
    return axios({
        method:'post',
        url: "http://10.200.5.56:8081/paymentplatform/bankzzApiMain",
        // url: "/api",
        data: {
          "infcode":code,
          "input":input
        }
      }).then(res => {
        //console.log(res)
        return res.data;     
      }).catch(err => {
        //console.error(err); 
        return err.data        
      });
  },
    // alipay(input){
    //   return axios({
    //       method:'get',
    //       url: "/data/alipay.json",
    //       data: {
    //         "input":input
    //       }
    //     }).then(res => {
    //       //console.log(res)
    //       return res.data;     
    //     }).catch(err => {
    //       //console.error(err); 
    //       return err.data        
    //   });
    // },
    pay(patid,input,url){
      console.log("pay",url)

      return axios({
        method:'post',
        url: 'http://10.200.5.56:8081/pay/api'+url,
        // url: '/interface_pay'+url,
        headers: { 
          //'User-Agent': 'apifox/1.0.0 (https://www.apifox.cn)', 
          'Content-Type': 'application/json',
          'pid':patid
       },
        data: {  
          data:input,
          qqflag:"0"
        }
      }).then(res => {
        console.log(res)
        return res.data;     
      }).catch(err => {
        console.error(err); 
        return err.data        
      });
    },

    

    isTokenExpired(){
      let tokenYxsj = store.state.publicStore.tokenYxsj 
      let curTime = new Date().getTime()

      if(curTime - Number(tokenYxsj) >= 18000000){
        return false
      }
      
      return true
    },
    
    async refreshToken(){
      //判断token非空并且有效
      let authorization = store.state.publicStore.token
      console.log("authorization1",authorization)
      console.log("authorization2",this.isTokenExpired())
      if(authorization != null && authorization != ""  && this.isTokenExpired()){
        return authorization
      }

      let data = {
        userId:store.state.publicStore.userId,
        passWord:store.state.publicStore.passWord,
        userName:store.state.publicStore.userName
      }

      return await axios({
        method:'post',
        url: 'http://10.200.5.56:8081'+"/authorization",
        // url: '/interface_token'+"/authorization",
        headers: { 
          'Content-Type': 'application/json'   
       },
        data: {
          data:data,
          qqflag:"0"
        }
      }).then(res => {
        console.log(res)
        store.dispatch('changeToken', res.data);
        store.dispatch('changeTokenYxsj', new Date().getTime());
        return res.data;     
      }).catch(err => {
        console.error(err); 
        return err.data        
      });
    }
}

